import {
	all,
	compose,
	equals,
	flatten,
	identity,
	includes,
	isEmpty,
	memoizeWith,
	not,
	path,
	pathOr,
	propOr,
	values,
} from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { createSelector } from 'reselect';

// eslint-disable-next-line import/no-cycle
import taskOverview from 'features/views/taskOverview';
import { emptyArr, emptyObj } from 'utils';

import { FILTER_TYPE, NAME } from './constants';
// eslint-disable-next-line import/no-cycle
import { mapTasksToCard } from './utils';

export const getRoot = path([NAME]);

const getById = compose(pathOr(emptyObj, ['byIds']), getRoot);

export const getSelectedTaskIds = compose(pathOr(emptyArr, ['selectedTaskIds']), getRoot);

export const getMarkSelectedAllStateById = (taskTypeId) =>
	compose(pathOr(false, ['selectedAll', `${taskTypeId}`]), getRoot);

export const getMarkSelectedAll = compose(pathOr(false, ['selectedAll']), getRoot);

export const getAllSelected = memoizeWith(identity, (taskTypeId) =>
	createSelector(
		getTypeTasksById(taskTypeId),
		getSelectedTaskIdsById(taskTypeId),
		getMarkSelectedAllStateById(taskTypeId),
		(tasks, selectedTaskIds, markSelectedAllState) => {
			return markSelectedAllState
				? isEmpty(selectedTaskIds)
				: all(equals(true))(tasks.map((task) => includes(task.id, selectedTaskIds))) || markSelectedAllState;
		},
	),
);

export const checkIfProcessable = createSelector(
	getMarkSelectedAll,
	getSelectedTaskIds,
	(_, taskTypesCodelist) => taskTypesCodelist,
	(selectedAll, selectedTasks, taskTypesCodelist) => {
		let atLeastOneSelectedInformation = false;

		for (const taskType of taskTypesCodelist) {
			const id = taskType.id;
			const isInformation = taskType.informative === 1;
			const isSelectedAll = selectedAll[id];
			const hasSelectedItems = selectedTasks[id] && selectedTasks[id].length > 0;

			if (isInformation) {
				if (isSelectedAll) {
					atLeastOneSelectedInformation = true;
				} else if (hasSelectedItems) {
					atLeastOneSelectedInformation = true;
				}
			} else {
				if (isSelectedAll) {
					return false;
				} else if (hasSelectedItems) {
					return false;
				}
			}
		}

		return atLeastOneSelectedInformation;
	},
);

export const getPageIds = (taskTypeId) =>
	createSelector(taskOverview.selectors.getSubheaderState, getRoot, (filterOpen, state) =>
		pathOr(emptyArr, [filterOpen ? FILTER_TYPE.custom : FILTER_TYPE.quick, `${taskTypeId}`])(state),
	);

export const getTypeTasksById = memoizeWith(identity, (taskTypeId) =>
	createSelector(
		getById,
		taskOverview.selectors.getSubheaderState,
		taskOverview.selectors.getQuickFilterState,
		getPageIds(taskTypeId),
		mapTasksToCard,
	),
);

export const getAllTasks = compose(pathOr(emptyObj, ['byIds']), getRoot);

export const getSelectedTaskIdsById = (taskTypeId) =>
	compose(pathOr(emptyArr, ['selectedTaskIds', `${taskTypeId}`]), getRoot);

export const getSelectedTaskIdsFlatten = createSelector(getSelectedTaskIds, compose(flatten, values));

export const hasSelectedTasks = compose(not, isEmpty, getSelectedTaskIdsFlatten);

export const getTypesSorts = createSelector(getRoot, propOr('', 'typesSort'));
export const getPersistTypeTasksVisibleState = createSelector(getRoot, propOr(false, 'persistTypeTasksVisibleState'));

export const getSortValueByTaskType = createSelector(
	getTypesSorts,
	(_, taskTypeId) => taskTypeId,
	(allSorts, taskTypeId) => {
		return !isNilOrEmpty(taskTypeId) ? allSorts[taskTypeId] : null;
	},
);
